import React from "react";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";

export default function Dashboard() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("admin");
    navigate("/super-secret-login-3921");
  };

  return (
    <div className="dashboard-container">
      <h1>Welcome to Admin Panel</h1>
      <p>
        Manage your furniture products, add new items, edit existing ones, or monitor activity.
      </p>

      <div className="dashboard-buttons">
        <button className="dashboard-btn" onClick={() => navigate("/super-secret-add-card")}>
          Add New Product
        </button>
        <button className="dashboard-btn" onClick={() => navigate("/super-secret-work-cards")}>
          Manage Products
        </button>
        <button className="dashboard-btn logout" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}
